export var VenueRoutes;
(function (VenueRoutes) {
    VenueRoutes["VENUE"] = "customer/venue";
})(VenueRoutes || (VenueRoutes = {}));
